import { render, staticRenderFns } from "./_firstDeposit.vue?vue&type=template&id=5e56a570&scoped=true&lang=pug"
import script from "./_firstDeposit.vue?vue&type=script&lang=js"
export * from "./_firstDeposit.vue?vue&type=script&lang=js"
import style0 from "./_firstDeposit.vue?vue&type=style&index=0&id=5e56a570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56a570",
  null
  
)

export default component.exports